import { Navigate } from "react-router-dom";
import { EduViaOSMark, EduViaOSWordmark, LoadingScreen } from "@eduviaos/ui-kit";
import { useAuth } from "@/auth/AuthProvider";
import { LoginForm } from "@/components/LoginForm";

export function LoginPage() {
  const { status } = useAuth();
  // If a session is already restored, bounce to the dashboard.
  if (status === "authed") return <Navigate to="/dashboard" replace />;
  // Avoid flashing the form during the initial cookie-refresh.
  if (status === "loading") {
    return (
      <main>
        <LoadingScreen label="Restoring session…" />
      </main>
    );
  }
  return (
    <main className="bg-muted/30 grid min-h-svh place-items-center px-4 py-10">
      <div className="grid w-full max-w-sm gap-6">
        <div className="grid justify-items-center gap-1.5 text-center">
          <h1 className="flex items-center gap-2.5 text-2xl">
            <EduViaOSMark className="size-9" />
            <EduViaOSWordmark />
          </h1>
          <p className="text-muted-foreground text-sm">Institution administration portal</p>
        </div>
        <LoginForm />
      </div>
    </main>
  );
}
